import FormPassword from '../templates/FormPassword';
import { FormItemProps } from '../templates/FormProps';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const Password = ({
  name = 'password',
  label = 'Password',
  placeholder = 'Enter password',
  disabled,
  rules,
  required = true,
  setEditItem,
  ...props
}: FormItemProps): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const stateRules: any = [
      {
        validator: async (rule, value) => {
          if (!value) return Promise.resolve();
          // var strongRegex = new RegExp(
          //   '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
          // );
          const strongRegex = [
            /^(?=.*[a-z])/, // Check for lowercase
            /^(?=.*[A-Z])/, // Check for uppercase
            /^(?=.*[0-9])/, // Check for numbers
            /^(?=.*[!@#$%^&*])/, // Check for special characters
            /^(?=.{8,})/, // Check for length
          ];

          return strongRegex.every((regex) => regex.test(value))
            ? Promise.resolve()
            : Promise.reject(t('Not strong enough'));
        },
      },
    ];

    if (required) stateRules.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) stateRules.push(...rules);

    return stateRules;
  }, [t, required, rules]);

  return (
    <FormPassword
      autoComplete="new-password"
      {...{ name, label, placeholder, disabled }}
      rules={rulesMemo}
      {...props}
    />
  );
};

export default Password;
